
import { defineComponent, ref, watch, watchEffect } from 'vue'
import EditableField from '@/components/_shared/editable-field.vue'
import { useFormModule } from '@/modules/_shared/forms'
import QForm from 'quasar/src/components/form/QForm.js';
import { useMemberModule } from '@/modules/members'
import { useRoute } from 'vue-router'

export default defineComponent({
    name: 'members-editable-field-email',
    props: {
        modelValue: {
            type: String,
            required: true
        }
    },
    components: {
        EditableField
    },
    setup (props, { emit }) {
        const route = useRoute()
        const { updateMemberEmail } = useMemberModule()
        const { submitForm, createOnSuccess, validations } = useFormModule()
        const localValue = ref(props.modelValue)
        const form = ref<QForm>()

        watchEffect(() => {
            localValue.value = props.modelValue
        })

        watch(localValue, () => {
            submitForm(
                form.value,
                async () => updateMemberEmail(
                    route.params.memberId as string,
                    {
                        memberId: route.params.memberId as string,
                        email: localValue.value
                    }),
                () => {
                    emit('update:modelValue', localValue.value)
                    createOnSuccess('Member email updated')()
                }
            )
        })

        return {
            validations,
            localValue,
            form
        }
    }
})
